<template>
  <div class="modal" data-backdrop="static" id="bsInvoiceDeleteFormDialog" ref="bsInvoiceDeleteFormDialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <form name="deleteInvoice"
              :action="'deleteInvoice' | url(pUrls)"
              method="post" class="form-vertical ajax-support show-waiting"
              data-ajax-support-csv="#ajaxModuleForm"
              data-ajax-legacy="true">

          <input type="hidden" name="deleteDataForm.data.id" :value="data.id"/>

          <input type="hidden" name="src" :value="pSrc"/>
          <input type="hidden" name="srcId" :value="pSrcId"/>

          <input type="hidden" name="confirm" value="true"/>

          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h3 class="modal-title">{{'dictionary.invoice.delete.title' | i18nText(pDictionary)}}</h3>
          </div>
          <div class="modal-body max-height warning">
            <h3>{{'dictionary.invoice.delete.consequence.warning' | i18nText(pDictionary)}}</h3>
            <h4>{{confirmationKey | i18nText(pDictionary) | i18nparams(0, data.reference)}}</h4>
          </div>
          <div class="modal-footer">
            <div class="text-right">
              <button type="submit" class="btn btn-primary">
                <i class="fa-light fa-check"></i> <span>{{ 'dictionary.actions.yes' | i18nText(pDictionary) }}</span>
              </button>
              <a href="#"
                 class="btn btn-link" data-dismiss="modal" aria-label="No">{{ 'dictionary.actions.no' | i18nText(pDictionary) }}</a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormatMixin from "@/mixins/format-mixin";
import FormMixin from "@/mixins/form-mixin";
import stringHelpers from "@/helpers/string-helpers";

export default {
  name: "InvoiceDeleteForm",
  mixins: [BaseMixin, FormatMixin, FormMixin],
  props: {
    pDataForm: Object
  },
  data: function () {
    return {
      data: this.pDataForm.data
    }
  },
  computed: {
    confirmationKey: function() {
      return stringHelpers.isEmptyOrNull(this.data.reference) ?
             "dictionary.invoice.delete.confirmation.noref" :
             "dictionary.invoice.delete.confirmation"
    }
  },
  mounted: function () {
    $(this.$refs.bsInvoiceDeleteFormDialog).modal();
  }
}
</script>

<style scoped>

</style>